/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Targetjobservicev1FolderStats } from '../models/Targetjobservicev1FolderStats';
import { HttpFile } from '../http/http';

/**
* Response containing the list of audience folders
*/
export class V1ListAudienceFoldersResponse {
    'folders'?: Array<Targetjobservicev1FolderStats>;
    /**
    * the page token to send to retrieve the next page of results.
    */
    'nextPageToken'?: string;
    'totalSize'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "folders",
            "baseName": "folders",
            "type": "Array<Targetjobservicev1FolderStats>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return V1ListAudienceFoldersResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

